__turbopack_context__.v({
  "innerWrapper": "styles-module__eovNMG__innerWrapper",
  "wrapper": "styles-module__eovNMG__wrapper",
});
